export default "/images/defaultBook.png?58a418eeca17025ed6982ece1f9e1019";